import { MultiSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	const values = [items[0], items[1], items[2]];
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="limit:1" />
			<Text semiBold text="limit:2" />
			<MultiSelect
				limitTags={1}
				options={items}
				value={values}
			/>
			<MultiSelect
				limitTags={2}
				options={items}
				value={values}
			/>
		</CssColumnGrid>
	);
};